import { render, staticRenderFns } from "./SMSProviderRecord.vue?vue&type=template&id=b3827e0c&scoped=true&"
import script from "./SMSProviderRecord.vue?vue&type=script&lang=js&"
export * from "./SMSProviderRecord.vue?vue&type=script&lang=js&"
import style0 from "./SMSProviderRecord.vue?vue&type=style&index=0&id=b3827e0c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3827e0c",
  null
  
)

export default component.exports